import React from 'react'
import { plainChatSpans, type ChatSpan } from '../../lib/chatText'
export interface ChatFlowProps { content: string; authorName: string; timestamp: string; leading?: React.ReactNode; reactions?: React.ReactNode; counts: number[]; compact: boolean }
export function useChatFlowSpans(content: string, authorName: string) {
  return React.useMemo<ChatSpan[]>(() => [{ text: `💬 ${authorName}: `, bold: true, author: true }, ...plainChatSpans(content)], [content, authorName])
}
export function flowReactionNode(node: React.ReactNode, columns = 3) {
  return React.isValidElement<{ size?: 'small'; maxPerRow?: number }>(node) ? React.cloneElement(node, { size: 'small', maxPerRow: Math.max(1, columns) }) : node
}
